<template>
  <v-container class="fill-height d-flex align-center flex-wrap" fluid>
    <v-row class="fill-height">
      <v-col class="align-self-center text-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
  export default {
    name: 'loading-circle',
  };
</script>

<style scoped></style>
